export default __webpack_public_path__ + "11a07e70695de867852ac9b3ae5a3caf.png";